import type { RankingEntry } from './ranking';

// 백엔드 연결 전, localStorage 가 비어 있을 때 한 번 시드되는 더미 랭킹.
// 실제 서버 연동 후에는 이 모듈을 삭제하고 RemoteRankingService 로 교체할 것.

type Row = readonly [companyName: string, nickname: string, score: number];

// 테스트용: 점수 1~100 시퀀셜 더미 (초반 추월/grave 표시 검증용)
const TEST_COMPANIES = [
  '롯데 케미칼',
  'BEYOU',
  '야탑유스센터',
  '디피니트',
  '디블러',
  'GS에너지',
  '메타리치',
  '알로하팩토리',
];
const TEST_NAMES = [
  '주현', '민지', '소영', '태경', '경수', '하늘', '바다', '별이', '유리', '은별',
  '서영', '나래', '소진', '하영', '은지', '예린', '시아', '리아', '나리', '다영',
  '다현', '미나', '윤아', '소희', '예지', '아인', '서연', '재인', '주아', '시연',
  'JIN', 'AMY', 'BEN', 'CHEN', 'DAVID', 'EVA', 'FINN', 'GIA', 'HAN', 'IVY',
  'JAY', 'KAI', 'LEO', 'MIA', 'NICK', 'OLIVE', 'POLO', 'QUIN', 'ROY', 'SOFI',
];

const LOW_SCORE_ROWS: ReadonlyArray<Row> = Array.from({ length: 100 }, (_, i) => [
  TEST_COMPANIES[i % TEST_COMPANIES.length] ?? 'BEYOU',
  TEST_NAMES[i % TEST_NAMES.length] ?? `P${i}`,
  i + 1,
]);

const HIGH_SCORE_ROWS: ReadonlyArray<Row> = [
  // 롯데 케미칼 (22)
  ['롯데 케미칼', '민준', 1520],
  ['롯데 케미칼', '서준', 1340],
  ['롯데 케미칼', '도윤', 1180],
  ['롯데 케미칼', '예준', 980],
  ['롯데 케미칼', '시우', 870],
  ['롯데 케미칼', '주원', 810],
  ['롯데 케미칼', '하준', 720],
  ['롯데 케미칼', '지호', 680],
  ['롯데 케미칼', '지후', 610],
  ['롯데 케미칼', '준우', 580],
  ['롯데 케미칼', 'CHEMI', 550],
  ['롯데 케미칼', '준서', 510],
  ['롯데 케미칼', '도현', 470],
  ['롯데 케미칼', '현우', 420],
  ['롯데 케미칼', '우진', 380],
  ['롯데 케미칼', 'ROCKET', 340],
  ['롯데 케미칼', '선우', 290],
  ['롯데 케미칼', '서진', 250],
  ['롯데 케미칼', '민재', 210],
  ['롯데 케미칼', '현준', 170],
  ['롯데 케미칼', '연우', 130],
  ['롯데 케미칼', '정우', 90],

  // BEYOU (5)
  ['BEYOU', 'DAN', 1820],
  ['BEYOU', 'DEBB', 1450],
  ['BEYOU', 'HARRY', 1100],
  ['BEYOU', 'JOY', 720],
  ['BEYOU', 'SAM', 410],

  // 야탑유스센터 (22)
  ['야탑유스센터', '승우', 1620],
  ['야탑유스센터', '시윤', 1280],
  ['야탑유스센터', '유준', 1130],
  ['야탑유스센터', '은우', 1040],
  ['야탑유스센터', 'YOUTH', 920],
  ['야탑유스센터', '윤우', 850],
  ['야탑유스센터', '건우', 780],
  ['야탑유스센터', '지원', 720],
  ['야탑유스센터', '시현', 650],
  ['야탑유스센터', '채원', 600],
  ['야탑유스센터', '지우', 540],
  ['야탑유스센터', 'CENTER', 480],
  ['야탑유스센터', '수현', 420],
  ['야탑유스센터', '준혁', 360],
  ['야탑유스센터', '민성', 320],
  ['야탑유스센터', '동현', 280],
  ['야탑유스센터', '시환', 240],
  ['야탑유스센터', 'YATAP', 200],
  ['야탑유스센터', '우현', 170],
  ['야탑유스센터', '정후', 140],
  ['야탑유스센터', '한결', 110],
  ['야탑유스센터', '도연', 80],

  // 디피니트 (8)
  ['디피니트', '영호', 1700],
  ['디피니트', '지수', 1380],
  ['디피니트', 'DEFINITE', 1050],
  ['디피니트', '다영', 850],
  ['디피니트', '민서', 620],
  ['디피니트', '수빈', 480],
  ['디피니트', 'KIM', 340],
  ['디피니트', '소현', 220],

  // 디블러 (6)
  ['디블러', 'BLUR', 1900],
  ['디블러', '태현', 1230],
  ['디블러', '지민', 970],
  ['디블러', '가람', 750],
  ['디블러', '다온', 530],
  ['디블러', '누리', 380],

  // GS에너지 (28)
  ['GS에너지', 'ENERGY', 2180],
  ['GS에너지', '진우', 1750],
  ['GS에너지', '성민', 1490],
  ['GS에너지', '재현', 1320],
  ['GS에너지', '윤호', 1230],
  ['GS에너지', '동훈', 1120],
  ['GS에너지', '광수', 1010],
  ['GS에너지', '명진', 940],
  ['GS에너지', '종민', 880],
  ['GS에너지', 'POWER', 820],
  ['GS에너지', '영준', 770],
  ['GS에너지', '호진', 710],
  ['GS에너지', '상우', 660],
  ['GS에너지', '일권', 610],
  ['GS에너지', '영석', 560],
  ['GS에너지', '태진', 510],
  ['GS에너지', '종한', 460],
  ['GS에너지', '인후', 410],
  ['GS에너지', '재석', 370],
  ['GS에너지', '만호', 320],
  ['GS에너지', '형주', 280],
  ['GS에너지', '영근', 240],
  ['GS에너지', '우식', 200],
  ['GS에너지', '영태', 170],
  ['GS에너지', 'SPARK', 150],
  ['GS에너지', '광호', 130],
  ['GS에너지', '형수', 110],
  ['GS에너지', '도균', 70],

  // 메타리치 (5)
  ['메타리치', 'RICH', 1860],
  ['메타리치', 'META', 1410],
  ['메타리치', '호영', 980],
  ['메타리치', '미선', 580],
  ['메타리치', '보영', 270],

  // 알로하팩토리 (4)
  ['알로하팩토리', 'ALOHA', 1930],
  ['알로하팩토리', '케이', 1310],
  ['알로하팩토리', '마노', 760],
  ['알로하팩토리', '카이', 360],
];

const ROWS: ReadonlyArray<Row> = [...LOW_SCORE_ROWS, ...HIGH_SCORE_ROWS];

const SEED_BASE_MS = Date.UTC(2026, 3, 15, 9, 0, 0); // 2026-04-15 09:00 UTC
const STEP_MS = 3 * 60 * 60 * 1000; // 3시간 간격으로 분산

export const DUMMY_RANKING: ReadonlyArray<RankingEntry> = ROWS.map(
  ([companyName, nickname, score], i) => ({
    rank: 0,
    companyName,
    nickname,
    score,
    recordedAt: new Date(SEED_BASE_MS + i * STEP_MS).toISOString(),
  }),
);
